"use strict";

var _regeneratorRuntime = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsontokens_1 = require("jsontokens");

var dids_1 = require("../dids");

var keys_1 = require("../keys");

var utils_1 = require("../utils");

var fetchUtil_1 = require("../fetchUtil");

var authProvider_1 = require("./authProvider");
/**
 * Checks if the ES256k signature on passed `token` match the claimed public key
 * in the payload key `public_keys`.
 *
 * @param  {String} token encoded and signed authentication token
 * @return {Boolean} Returns `true` if the signature matches the claimed public key
 * @throws {Error} if `token` contains multiple public keys
 * @private
 * @ignore
 */


function doSignaturesMatchPublicKeys(token) {
  var payload = jsontokens_1.decodeToken(token).payload;

  if (typeof payload === 'string') {
    throw new Error('Unexpected token payload type of string');
  }

  var publicKeys = payload.public_keys;

  if (publicKeys.length === 1) {
    var publicKey = publicKeys[0];

    try {
      var tokenVerifier = new jsontokens_1.TokenVerifier('ES256k', publicKey);
      var signatureVerified = tokenVerifier.verify(token);

      if (signatureVerified) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  } else {
    throw new Error('Multiple public keys are not supported');
  }
}

exports.doSignaturesMatchPublicKeys = doSignaturesMatchPublicKeys;
/**
 * Makes sure that the identity address portion of
 * the decentralized identifier passed in the issuer `iss`
 * key of the token matches the public key
 *
 * @param  {String} token encoded and signed authentication token
 * @return {Boolean} if the identity address and public keys match
 * @throws {Error} if ` token` has multiple public keys
 * @private
 * @ignore
 */

function doPublicKeysMatchIssuer(token) {
  var payload = jsontokens_1.decodeToken(token).payload;

  if (typeof payload === 'string') {
    throw new Error('Unexpected token payload type of string');
  }

  var publicKeys = payload.public_keys;
  var addressFromIssuer = dids_1.getAddressFromDID(payload.iss);

  if (publicKeys.length === 1) {
    var addressFromPublicKeys = keys_1.publicKeyToAddress(publicKeys[0]);

    if (addressFromPublicKeys === addressFromIssuer) {
      return true;
    }
  } else {
    throw new Error('Multiple public keys are not supported');
  }

  return false;
}

exports.doPublicKeysMatchIssuer = doPublicKeysMatchIssuer;
/**
 * Looks up the identity address that owns the claimed username
 * in `token` using the lookup endpoint provided in `nameLookupURL`
 * to determine if the username is owned by the identity address
 * that matches the claimed public key
 *
 * @param  {String} token  encoded and signed authentication token
 * @param  {String} nameLookupURL a URL to the name lookup endpoint of the Blockstack Core API
 * @return {Promise<Boolean>} returns a `Promise` that resolves to
 * `true` if the username is owned by the public key, otherwise the
 * `Promise` resolves to `false`
 * @private
 * @ignore
 */

function doPublicKeysMatchUsername(token, nameLookupURL) {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var payload, username, url, response, responseText, responseJSON, nameOwningAddress, addressFromIssuer;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            payload = jsontokens_1.decodeToken(token).payload;

            if (!(typeof payload === 'string')) {
              _context.next = 4;
              break;
            }

            throw new Error('Unexpected token payload type of string');

          case 4:
            if (payload.username) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", true);

          case 6:
            if (!(payload.username === null)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", true);

          case 8:
            if (!(nameLookupURL === null)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", false);

          case 10:
            username = payload.username;
            url = "".concat(nameLookupURL.replace(/\/$/, ''), "/").concat(username);
            _context.next = 14;
            return fetchUtil_1.fetchPrivate(url);

          case 14:
            response = _context.sent;
            _context.next = 17;
            return response.text();

          case 17:
            responseText = _context.sent;
            responseJSON = JSON.parse(responseText);

            if (!responseJSON.hasOwnProperty('address')) {
              _context.next = 29;
              break;
            }

            nameOwningAddress = responseJSON.address;
            addressFromIssuer = dids_1.getAddressFromDID(payload.iss);

            if (!(nameOwningAddress === addressFromIssuer)) {
              _context.next = 26;
              break;
            }

            return _context.abrupt("return", true);

          case 26:
            return _context.abrupt("return", false);

          case 27:
            _context.next = 30;
            break;

          case 29:
            return _context.abrupt("return", false);

          case 30:
            _context.next = 37;
            break;

          case 32:
            _context.prev = 32;
            _context.t0 = _context["catch"](0);
            console.log(_context.t0);
            console.log('Error checking `doPublicKeysMatchUsername`');
            return _context.abrupt("return", false);

          case 37:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 32]]);
  }));
}

exports.doPublicKeysMatchUsername = doPublicKeysMatchUsername;
/**
 * Checks if the if the token issuance time and date is after the
 * current time and date.
 *
 * @param  {String}  token encoded and signed authentication token
 * @return {Boolean} `true` if the token was issued after the current time,
 * otherwise returns `false`
 * @private
 * @ignore
 */

function isIssuanceDateValid(token) {
  var payload = jsontokens_1.decodeToken(token).payload;

  if (typeof payload === 'string') {
    throw new Error('Unexpected token payload type of string');
  }

  if (payload.iat) {
    if (typeof payload.iat !== 'number') {
      return false;
    }

    var issuedAt = new Date(payload.iat * 1000); // JWT times are in seconds

    if (new Date().getTime() < issuedAt.getTime()) {
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
}

exports.isIssuanceDateValid = isIssuanceDateValid;
/**
 * Checks if the expiration date of the `token` is before the current time
 * @param  {String}  token encoded and signed authentication token
 * @return {Boolean} `true` if the `token` has not yet expired, `false`
 * if the `token` has expired
 *
 * @private
 * @ignore
 */

function isExpirationDateValid(token) {
  var payload = jsontokens_1.decodeToken(token).payload;

  if (typeof payload === 'string') {
    throw new Error('Unexpected token payload type of string');
  }

  if (payload.exp) {
    if (typeof payload.exp !== 'number') {
      return false;
    }

    var expiresAt = new Date(payload.exp * 1000); // JWT times are in seconds

    if (new Date().getTime() > expiresAt.getTime()) {
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
}

exports.isExpirationDateValid = isExpirationDateValid;
/**
 * Makes sure the `manifest_uri` is a same origin absolute URL.
 * @param  {String}  token encoded and signed authentication token
 * @return {Boolean} `true` if valid, otherwise `false`
 * @private
 * @ignore
 */

function isManifestUriValid(token) {
  var payload = jsontokens_1.decodeToken(token).payload;

  if (typeof payload === 'string') {
    throw new Error('Unexpected token payload type of string');
  }

  return utils_1.isSameOriginAbsoluteUrl(payload.domain_name, payload.manifest_uri);
}

exports.isManifestUriValid = isManifestUriValid;
/**
 * Makes sure the `redirect_uri` is a same origin absolute URL.
 * @param  {String}  token encoded and signed authentication token
 * @return {Boolean} `true` if valid, otherwise `false`
 * @private
 * @ignore
 */

function isRedirectUriValid(token) {
  var payload = jsontokens_1.decodeToken(token).payload;

  if (typeof payload === 'string') {
    throw new Error('Unexpected token payload type of string');
  }

  return utils_1.isSameOriginAbsoluteUrl(payload.domain_name, payload.redirect_uri);
}

exports.isRedirectUriValid = isRedirectUriValid;
/**
 * Verify authentication request is valid. This function performs a number
 * of checks on the authentication request token:
 * * Checks that `token` has a valid issuance date & is not expired
 * * Checks that `token` has a valid signature that matches the public key it claims
 * * Checks that both the manifest and redirect URLs are absolute and conform to
 * the same origin policy
 *
 * @param  {String} token encoded and signed authentication request token
 * @return {Promise} that resolves to true if the auth request
 *  is valid and false if it does not. It rejects with a String if the
 *  token is not signed
 * @private
 * @ignore
 */

function verifyAuthRequest(token) {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var values;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(jsontokens_1.decodeToken(token).header.alg === 'none')) {
              _context2.next = 2;
              break;
            }

            throw new Error('Token must be signed in order to be verified');

          case 2:
            _context2.next = 4;
            return Promise.all([isExpirationDateValid(token), isIssuanceDateValid(token), doSignaturesMatchPublicKeys(token), doPublicKeysMatchIssuer(token), isManifestUriValid(token), isRedirectUriValid(token)]);

          case 4:
            values = _context2.sent;
            return _context2.abrupt("return", values.every(function (val) {
              return val;
            }));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.verifyAuthRequest = verifyAuthRequest;
/**
 * Verify the authentication request is valid and
 * fetch the app manifest file if valid. Otherwise, reject the promise.
 * @param  {String} token encoded and signed authentication request token
 * @return {Promise} that resolves to the app manifest file in JSON format
 * or rejects if the auth request or app manifest file is invalid
 * @private
 * @ignore
 */

function verifyAuthRequestAndLoadManifest(token) {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var valid;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return verifyAuthRequest(token);

          case 2:
            valid = _context3.sent;

            if (valid) {
              _context3.next = 5;
              break;
            }

            throw new Error('Token is an invalid auth request');

          case 5:
            return _context3.abrupt("return", authProvider_1.fetchAppManifest(token));

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

exports.verifyAuthRequestAndLoadManifest = verifyAuthRequestAndLoadManifest;
/**
 * Verify the authentication response is valid
 * @param {String} token the authentication response token
 * @param {String} nameLookupURL the url use to verify owner of a username
 * @return {Promise} that resolves to true if auth response
 * is valid and false if it does not
 * @private
 * @ignore
 */

function verifyAuthResponse(token, nameLookupURL) {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4() {
    var values;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return Promise.all([isExpirationDateValid(token), isIssuanceDateValid(token), doSignaturesMatchPublicKeys(token), doPublicKeysMatchIssuer(token), doPublicKeysMatchUsername(token, nameLookupURL)]);

          case 2:
            values = _context4.sent;
            return _context4.abrupt("return", values.every(function (val) {
              return val;
            }));

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}

exports.verifyAuthResponse = verifyAuthResponse;